import React from "react";
import { Select } from "antd";
import Badge from "../Badge";
const { Option } = Select;

type RealSelectProps = {
  items: {
    value: string;
    label: JSX.Element | string;
    optionRender: JSX.Element | string;
    disabled: boolean;
  }[];
  dropdownStyle: React.CSSProperties;
  value: JSX.Element | string | number;
  className: string;
  disabled: boolean;
  defaultValue: string | number;
  onChange: (value: string | number) => void;
};

const RealSelect = ({
  items = [],
  dropdownStyle,
  defaultValue,
  className,
  disabled,
  onChange,
}: RealSelectProps): JSX.Element => {
  return (
    <Select
      dropdownStyle={dropdownStyle}
      defaultValue={defaultValue}
      labelInValue
      optionLabelProp="label"
      className={className}
      disabled={disabled}
      onChange={(value) => onChange(value)}
    >
      {items.map((item) => {
        return (
          <Option value={item.value} label={item.label}>
            {item.optionRender}
          </Option>
        );
      })}
    </Select>
  );
};

export default RealSelect;
